export const csCZ = {
  app: {
    categories: {
      convectors: 'Konvektory',
      decorative: 'Dekorativní',
      electric: 'Elektrické',
      panels: 'Panely',
      towel: 'Sušáky ručníků',
    },
    categoryLabel: 'Kategorie',
    categoryPlaceholder: 'Vyberte kategorii',
    errorCategories: 'Nepodařilo se načíst kategorie.',
    errorPanels: 'Nepodařilo se načíst radiátory.',
    loadingCategories: 'Načítání kategorií...',
    loadingPanels: 'Načítání radiátorů...',
    panelLabel: 'Radiátory',
    panelPlaceholder: 'Vyberte radiátor',
    titles: {
      convectors: 'Kalkulačka konvektorů',
      decorative: 'Kalkulačka designových radiátorů',
      electric: 'Kalkulačka elektrických radiátorů',
      panels: 'Kalkulačka panelových radiátorů',
      towel: 'Kalkulačka sušáků ručníků',
    },
  },
  calc: {
    actionButton: 'Zobrazit vypočítané položky',
    boost: 'Turbo režim',
    calculateRequiredButton: 'Vypočítat požadované watty',
    calculating: 'Počítání...',
    comfort: 'Komfortní režim',
    downloadLabel: 'Stáhnout data ({count})',
    emptyResults: 'Zatím žádné výsledky.',
    errorMatch: 'Nepodařilo se vypočítat výsledky.',
    errorTypes: 'Nepodařilo se načíst typy radiátorů.',
    flowTemp: 'Teplota přívodu C°',
    height: 'Výška',
    length: 'Délka',
    loadingTypes: 'Načítání typů...',
    modeLabel: 'Režim',
    modes: {
      cooling: 'Chlazení',
      heating: 'Topení',
    },
    radiatorType: 'Typ radiátoru',
    requiredWatts: 'Požadované watty',
    resultsMessage: '{count} položek dostupných pro vybrané nastavení.',
    returnTemp: 'Teplota zpátečky C°',
    roomTemp: 'Teplota místnosti C°',
    selectAllLabel: 'Vybrat všechny položky',
    selectItemLabel: 'Vyberte položku ke stažení',
    selectPanel: 'Vyberte radiátor pro výpočet.',
    standby: 'Pohotovostní režim',
    tableHeaders: {
      calculatedWattage: 'Watty',
      co2Equivalent: 'CO2 ekvivalent na kg materiálu',
      depth: 'Hloubka [mm]',
      description: 'Popis položky',
      dop: 'DOP',
      eudop: 'EU DOP',
      height: 'Výška [mm]',
      itemId: 'Kód položky',
      length: 'Délka [mm]',
      waterContent: 'Obsah vody',
      weight: 'Hmotnost',
    },
    title: 'Výpočty',
    tolerance: 'Tolerance',
    typeCooling: 'Chlazení',
    typeGroupLabel: 'Typ',
    typeHeating: 'Topení',
  },
  existingRadiator: {
    description:
      'Tato kalkulačka je pouze informativní. Před zakoupením radiátoru vždy konzultujte přesný výpočet s odborným instalatérem.',
    height: 'Výška radiátoru',
    length: 'Délka radiátoru',
    resultLabelTemplate: 'Požadovaný tepelný výkon, vypočítaný při teplotě systému {temp}',
    select: 'Vybrat',
    temperature: 'Teplota systému',
    type: 'Typ radiátoru',
  },
  matrixCalc: {
    axisHeight: 'Výška (mm)',
    axisLength: 'Délka (mm)',
    axisType: 'Typ',
    calculateButton: 'Calculate',
    displayLabel: 'Zobrazení',
    exportExcel: 'Exportovat do Excelu',
    exportPdf: 'Exportovat do PDF',
    print: 'Tisk',
    hideOutOfRange: 'Skrýt položky mimo rozsah',
    showAll: 'Zobrazit vše',
    loading: 'Loading...',
    lockHeight: 'Výška',
    lockLabel: 'Zafixovat rozměr',
    lockLength: 'Délka',
    lockType: 'Typ',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Vypočítat',
    clearButton: 'Vymazat vše',
    fields: {
      ceilingHeight: 'Výška stropu',
      doorInsulation: 'Izolace dveří',
      floorInsulation: 'Izolace podlahy',
      glazingArea: 'Plocha zasklení',
      glazingMode: 'Plocha zasklení',
      glazingQuality: 'Kvalita zasklení',
      length: 'Délka',
      outerWalls: 'Vnější stěny',
      projectedDesignTemp: 'Návrhová venkovní teplota (NVT) v místě stavby',
      roofInsulation: 'Izolace střechy',
      roomArea: 'Plocha místnosti',
      roomFloor: 'Podlaží',
      roomInsulation: 'Izolace místnosti',
      roomPreset: 'Typ místnosti',
      roomTemperature: 'Teplota místnosti',
      roomType: 'Typ místnosti',
      uncertaintyFactor: 'Faktor nejistoty',
      ventilation: 'Úroveň větrání',
      wallInsulation: 'Izolace stěn',
      width: 'Šířka',
      windConditions: 'Větrné podmínky',
      windowInsulation: 'Izolace oken',
    },
    intro:
      'Vypočítejte tepelné ztráty místnosti a vyberte správný produkt z naší nabídky radiátorů.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Více než 20%',
        low: 'Méně než 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Nad 20%',
        below_10: 'Pod 10%',
        from_10_to_20: 'Od 10% do 20%',
        no_windows: 'Bez oken',
      },
      insulationValue: {
        good: 'Dobrá',
        medium: 'Střední',
        poor: 'Špatná',
        very_good: 'Velmi dobrá',
      },
      qualityValue: {
        modern_excellent: 'Moderní, výborná energetická účinnost',
        modern_good: 'Moderní, dobrá energetická účinnost',
        old_poor: 'Stará, velmi špatná energetická účinnost',
        traditional_medium: 'Tradiční, střední energetická účinnost',
      },
      roomValue: {
        bathroom_24: 'Koupelna (24 C°)',
        bedroom_20: 'Ložnice (20 C°)',
        garage_12: 'Garáž (12 C°)',
        livingroom_22: 'Obývací pokoj (22 C°)',
        storage_16: 'Sklad (16 C°)',
      },
      select: 'Vybrat',
      storeyValue: {
        ground_multi: 'Přízemí (vícepatrový dům)',
        ground_single: 'Přízemí (jednopodlažní dům)',
        interim: 'Střední podlaží',
        top_multi: 'Nejvyšší podlaží (vícepatrový dům)',
      },
      temp: {
        climate_zone_1: 'Midlands (-4C°)',
        climate_zone_2: 'Mírné pobřeží (-1,5C°)',
        climate_zone_3: 'Severní (-4,5C°)',
        climate_zone_4: 'Skotsko (-5,5C°)',
        climate_zone_5: 'Jižní (-3,5C°)',
        climate_zone_6: 'Velmi chladné nebo vysokohorské (-6,5C°)',
      },
      windInfluence: {
        normal: 'Normální',
        strong: 'Silný',
        weak: 'Slabý',
      },
    },
    roomPresets: {
      bathroom: 'Koupelna',
      bedroom: 'Ložnice',
      garage: 'Garáž',
      kitchen: 'Kuchyně',
      living: 'Obývací pokoj',
      storage: 'Sklad',
    },
    sections: {
      dimensions: 'Rozměry místnosti',
      insulation: 'Izolace',
      placement: 'Umístění',
      result: 'Výsledek',
      temps: 'Teploty',
      ventilation: 'Větrání',
    },
    title: 'Kalkulačka tepelných ztrát',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Použít',
  },
  slider: {
    from: 'Od',
    to: 'Do',
    value: 'Hodnota',
  },
}
